import ApiService from '@/api';
import {
  BaseProjectSearchResponse,
  ProjectNamespaceListRequest,
  ProjectNamespaceListResponse,
  ProjectSearchRequest,
  QueueModel,
} from '../models';
import GetListByProjectIdRequest from '@/api/Main/dataSource/api/projects/groups/i-service/model/queue-tasks/GetListByProjectIdRequest';
import { PaginationResponseModel } from '@/components/task-forms/models';
import { ResponseModel } from '@/models';
import TaskMoveRequestModel from '../../task-drawer/models/TaskMoveRequestModel';
import GetListStatusRequestModel from '../models/GetListStatusRequestModel';
import GetListStatusResponseModel from '../models/GetListStatusResponseModel';

/**Сервис для вызова api */
export class AdapterService {
  /**API сервис */
  api = new ApiService();

  /**Получение очередей */
  getQueues(req: GetListByProjectIdRequest): Promise<PaginationResponseModel<QueueModel[]>> {
    return new Promise(async (resolve) => {
      const result = new PaginationResponseModel<QueueModel[]>();
      await this.api.Main.ProjectQueueTaskService.getListByProjectIdAsync(req)
        .then((response) => {
          result.Items = response.Items.map(
            (x) =>
              new QueueModel({
                Id: x.QueueTaskId,
                Name: x.QueueTaskName,
                Count: x.TaskCount || 0,
                NamespaceId: x.Namespace.Id,
                IsQueueConfigured: x.IsQueueConfigured,
              }),
          );
          result.Count = response.Page.Count;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getTree', e);
          return resolve(result);
        });
    });
  }
  /**Перенос задачи в другую очередь */
  taskMove(request: TaskMoveRequestModel) {
    return new Promise<ResponseModel<Boolean>>(async (resolve) => {
      const result = new ResponseModel<Boolean>();

      await this.api.Main.ProjectTaskSaveService.taskMoveAsync(request)
        .then((resp) => {
          result.Value = resp;
          resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR moveTask', e);
          return resolve(result);
        });
    });
  }
  /**Получить список проектов */
  getProjects(req: ProjectSearchRequest): Promise<ResponseModel<BaseProjectSearchResponse>> {
    return new Promise((resolve) => {
      const result = new ResponseModel<BaseProjectSearchResponse>();

      this.api.Main.ProjectBaseService.searchAsync(req)
        .then((res) => {
          result.Value = res;
          resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR ProjectBaseService.Search', e);
          resolve(result);
        });
    });
  }
  /**
   * * Получить список неймспейсов
   * @param projectId ID проекта
   * @returns
   */
  getNamespaces(req: ProjectNamespaceListRequest) {
    return new Promise<ResponseModel<ProjectNamespaceListResponse>>(async (resolve) => {
      const result = new ResponseModel<ProjectNamespaceListResponse>();
      await this.api.Main.ProjectNamespaceService.getListAsync(req)
        .then((resp) => {
          result.Value = resp;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getNamespaces', e);
          return resolve(result);
        });
    });
  }
  /**
   * * Получение списка статусов с детальной информацией и фильтрами
   */
  async getStatusesListDetail(request: GetListStatusRequestModel) {
    return new Promise<ResponseModel<GetListStatusResponseModel>>(async (resolve) => {
      const result = new ResponseModel<GetListStatusResponseModel>();

      await this.api.Main.TaskStatusListService.getListAsync(request)
        .then((resp) => {
          result.Value = resp;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getNamespaces', e);
          return resolve(result);
        });
    });
  }
}
